import styled from 'styled-components'
import { NoMarginRow } from 'Components/EnhacedFlexboxGrid'
import { TEXT_GREY, OUTLINE_COLOR, FONT_BASE_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_MD } from '@CSSVars/variables'

import { _Table } from 'Components/Table/styles'

export const _SaleRentTableContainer = styled.div`
  position: relative;
`

export const _TableTHead = styled.thead`
  color: ${FONT_BASE_COLOR};
  th {
    color: ${FONT_BASE_COLOR} !important;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
  }
  td {
    &:first-child {
      min-width: 170px;
    }
  }
  @media screen and (max-width: 1023px) {
    td {
      min-width: 180px;
      &:first-child {
         min-width: 160px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    td {
      min-width: auto;
      &:first-child {
        min-width: auto;
      }
    }
  }
`

export const _PriceRange = styled.div`
  line-height: 22px;
  font-weight: 600;
  white-space: nowrap;
`

export const _SizeRange = styled.div`
  line-height: 22px;
  color: ${TEXT_GREY};
  font-size: 12px;
`


export const _OnlySmallScreen = styled(NoMarginRow)`
  display: none;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: flex;
    width: 100%;
    position: relative;
    table {
      margin-top: 22px;
      width: 100%;
    }
    td {
      padding: 10px 0;
    }
  }
`

export const _OnlyBigScreen = styled(_Table)`
  display: table;
  width: 100%;
  margin-bottom: 24px;
  tr {
    th {
      &:first-child {
        border-top-left-radius: 10px;
      }
      &:last-child {
        border-top-right-radius: 10px;
      }
    }
    td, th{
      border-left: 1px solid ${OUTLINE_COLOR};
      border-right: 1px solid ${OUTLINE_COLOR};
      &:first-child {
        border-left: 0;
      }
      &:last-child {
        border-right: 0;
      }
    }
    td {
      &:first-child {
        border-bottom-left-radius: 10px;
      }
      &:last-child {
        border-bottom-right-radius: 10px;
      }
    }
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _Edit = styled.div`
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
`

export const _PeriodSelectorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  height: 44px;
  border: 1px solid ${OUTLINE_COLOR};
  border-radius: 10px;
  width: 180px;
  position: absolute;
  right: 0;
  top: -54px;
  select {
    height: auto;
    padding: 0;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _SelectAndIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  select {
    padding-right: 1.5rem;
  }
  svg {
    position: absolute;
    top: 48%;
    right: 0.5rem;
    transform: translateY(-50%);
  }
`

export const _TableCell = styled.td`
  padding: 20px;
  text-align: center;
  backface-visibility: hidden;

`
export const _StatsTitle = styled.td`
  font-size: 14px;
  margin-top: 8px;
  font-weight: 600;
  line-height: 30px;
  width: 40%;
`

export const _StatsValue = styled.td`
  font-size: 14px;
  margin-top: 8px;
  font-weight: 500;
  line-height: 30px;
  width: 60%;
  height: 45px;
`


export const _Dropdown = styled.div`
  width: 100%;
  padding: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`
export const _MobileSubTitle = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  color: ${TEXT_GREY};
`

export const _Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 3px;

`

export const _TitleSubText = styled.div`
  color: ${TEXT_GREY};
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 32px;

`
